import BatteryWebsite from "./homepage";
function App() {
  return (
    <div>
      <BatteryWebsite/>
    </div>
  );
}

export default App;
